import {constant} from 'lodash/fp';

import {FETCH_RECENT_SEARCHES} from '/enum/launchSequence.enum';
import {getRecentSearches} from '/redux/action/search.action';
import {completedStepByName} from '/redux/selector/launchSequence.selector';
import {withProps} from '/util/selector.util';

export const fetchRecentSearchesTask = {
  stepName: FETCH_RECENT_SEARCHES,
  isCompleted: ({state}: any) =>
    // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
    withProps({stepName: FETCH_RECENT_SEARCHES})(completedStepByName)(state),
  perform: ({dispatch}: any) =>
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
    dispatch(getRecentSearches()).catch(constant(undefined)),
};
